import { Injectable } from '@angular/core';
import { BLOCKS } from '../../../data/blocks';
import { IBlock } from '../../../models/block.model.i';

@Injectable({
    providedIn: 'root'
})
export class BlockService {
    private _blocksMap: Map<number, IBlock>;

    constructor() {
        this._blocksMap = new Map(BLOCKS);
    }

    getBlock(id: number | string): IBlock {
        id = 'number' === typeof id ? id : Number.parseInt(id);
        return this._blocksMap.get(id);
    }
}
